import { QAlert, QText, QBox, QButton, QSpinner, useCurrentUser } from '@qualio/ui-components';
import { nanoid } from 'nanoid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import draftUpgradeApi from '../../../services/draftUpgradeApi';
import UpdateDraftsModal from '../Modal/UpdateDraftsModal';

type OldDraftsAlertProps = {
  templateId: string;
  version: number | string;
};

export const OldDraftsAlert: React.FC<OldDraftsAlertProps> = (props) => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const [upgradeLoadId, setUpgradeLoadId] = useState(nanoid());
  const { data, isLoading, error } = useQuery(['upgradableDrafts', props.templateId, upgradeLoadId], () =>
    draftUpgradeApi.getUpgradableDrafts(companyId, props.templateId),
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const closeModal = () => setModalIsOpen(false);
  const openModal = () => setModalIsOpen(true);

  const onUpgrade = () => {
    closeModal();
    setUpgradeLoadId(nanoid());
  };

  if (error) {
    return <QAlert description={t('template.updateDrafts.alert.error')} status="error" />;
  }
  if (isLoading) {
    return <QSpinner size="md" />;
  }

  if (data && data.total > 0) {
    return (
      <QBox data-cy="old-drafts-alert-box">
        <QAlert description={formDescription(data.total, openModal, t)} status="warning" title="" />
        <UpdateDraftsModal
          drafts={data.items}
          companyId={companyId}
          templateId={Number(props.templateId)}
          version={props.version}
          isOpen={modalIsOpen}
          onClose={closeModal}
          onSubmit={onUpgrade}
        />
      </QBox>
    );
  }
  return <></>;
};

function formDescription(numberOfDrafts: number, openModal: any, t: any) {
  const draftWord =
    numberOfDrafts > 1 ? t('template.updateDrafts.alert.drafts') : t('template.updateDrafts.alert.draft');
  const narrative =
    numberOfDrafts > 1 ? t('template.updateDrafts.alert.usingPlural') : t('template.updateDrafts.alert.usingSingular');
  return (
    <QText mt="1">
      <QButton variant="link" size="xs" onClick={openModal}>
        {numberOfDrafts} {draftWord}
      </QButton>{' '}
      {narrative}
    </QText>
  );
}
